module.exports = __webpack_public_path__ + "img/portfolio-guide-modal-illustration-fr1.127183d.png";